// extracted by mini-css-extract-plugin
module.exports = {"Checkbox":"Checkbox_Checkbox__C5cPw"};